import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import {
    IState,
    actions,
    mutations,
    getters
} from './index'
import cookie from '@/cookie'

Vue.use(Vuex)

export const makeStore = (): Store<IState> => new Vuex.Store<IState>({
    state: {
        currencies: [],
        currency: undefined,
        travel: undefined,
        filters: undefined,

        modal: undefined,
        order: undefined,

        version: 1,
        loading: false,
        theming: false,
        theme: cookie.get('TRA-theme'),
        platform: undefined,

        checkboxLabelCol: true,
        groupTravel: undefined,
        
        isShowEmailFormActive: false,
    },
    actions,
    mutations,
    getters
})
